import React, { Component } from 'react';
import { object } from 'underscore';

export default class WorkspaceNewVisualForm extends Component {

	constructor(props) {
		super(props);

		window.tmpDebug = this;

		let tmpNewCardForm = !this.props.isEditMode ? {
			title: "",
			chartType: null,
			dataSet: "blast",
			selectedMetrics: [],
			groupables: [],
			supportFields: [],
			isGroupable: false,
			isLocked: false,
			filters: {},
			expandedFilterMajors: [],
			activeFilter: null,
			isGrandTotals: false,
			stackedBarDatatype: null
		} : {
				id: this.props.cardIdentity.id,
				title: this.props.cardIdentity.title,
				chartType: this.props.cardIdentity.chartType,
				dataSet: this.props.cardIdentity.dataSet,
				selectedMetrics: Object.values(this.props.cardIdentity.selectedMetrics),
				groupables: Object.values(this.props.cardIdentity.groupables),
				supportFields: Object.values(this.props.cardIdentity.supportFields),
				isGroupable: this.props.cardIdentity.isGroupable,
				isLocked: this.props.cardIdentity.isLocked,
				filters: JSON.parse(JSON.stringify(this.updateFilters())),
				expandedFilterMajors: [],
				activeFilter: null,
				isGrandTotals: this.props.cardIdentity.isGrandTotals,
				stackedBarDatatype: this.props.cardIdentity.stackedBarDatatype != undefined ? this.props.cardIdentity.stackedBarDatatype : null
			}

		this.state = {
			phase: 0,
			newCardForm: tmpNewCardForm,
			search:"",
			searchMetric:"",
			searchYOY:"",
			searchGroupable:"",
			searchSupport:"",
			heightThreshold: 18,
			filters:{},
			metrics:{...this.props.metricTree},
			metricsYOY:{...this.props.metricTree},
			groupables:{...this.props.groupablesTree},
			supportFields:{...this.props.groupablesTree},
			stackedBarDatatype: null
		}

		this.outerHeights = [11.5, 21.15, 13.25, 20.25, 27.25, 14.5]

		this.movePhase = this.movePhase.bind(this);
		this.canContinue = this.canContinue.bind(this);

		this.createNewCardFilters = this.createNewCardFilters.bind(this);
		this.updateFilters = this.updateFilters.bind(this);

		this.handleNewCardTitleInput = this.handleNewCardTitleInput.bind(this);

		this.selectChartType = this.selectChartType.bind(this);
		this.selectDataSet = this.selectDataSet.bind(this);
		this.selectMetric = this.selectMetric.bind(this);
		this.selectAllMetrics = this.selectAllMetrics.bind(this);
		this.selectYOY = this.selectYOY.bind(this);
		this.selectAllYOY = this.selectAllYOY.bind(this);
		this.toggleIsGroupable = this.toggleIsGroupable.bind(this);
		this.toggleGrandTotals = this.toggleGrandTotals.bind(this);
		this.selectGroupable = this.selectGroupable.bind(this);
		this.selectAllGroupables = this.selectAllGroupables.bind(this);
		this.selectSupport = this.selectSupport.bind(this);
		this.toggleIsLocked = this.toggleIsLocked.bind(this);
		this.toggleAllDataSelected = this.toggleAllDataSelected.bind(this);
		this.filtersState = this.filtersState.bind(this);
		this.groupablesState = this.groupablesState.bind(this);

		this.finishCreateVisual = this.finishCreateVisual.bind(this);

		this.newCardSetActiveFilter = this.newCardSetActiveFilter.bind(this);
		this.newCardMakeFilterSelection = this.newCardMakeFilterSelection.bind(this);
		this.newCardMakeFilterMajorSelection = this.newCardMakeFilterMajorSelection.bind(this);
		this.newCardExpandFilterMajor = this.newCardExpandFilterMajor.bind(this);

		this.generateSlides = this.generateSlides.bind(this);
		this.saveCloseRender = this.saveCloseRender.bind(this);

		if (!this.props.isEditMode) {
			this.state.newCardForm = this.createNewCardFilters();
		}
	}

	componentDidMount() {
		this.setState({ filters:{...this.state.newCardForm.filters}});
		window.addEventListener('resize', () => {
			let heightThreshold = window.innerHeight < 750 ? 12 : 18;
			this.setState({heightThreshold: heightThreshold});
		})
	}

	updateFilters() {
		let filters = {
			...this.props.defaultFilters[this.props.cardIdentity.dataSet]
		};
		Object.keys(this.props.defaultFilters[this.props.cardIdentity.dataSet]).forEach(filter => {
			if(this.props.cardIdentity.filters[filter] === undefined) {
				filters = {
					...filters,
					[filter]:{
						...this.props.defaultFilters[this.props.cardIdentity.dataSet][filter]
					}
				}
			} else {
				let options = [], selected = [];
				this.props.defaultFilters[this.props.cardIdentity.dataSet][filter].options.forEach(opt => {
					options.push(opt);
					if(!this.props.cardIdentity.filters[filter].options.includes(opt)) {
						selected.push(opt);
					} else if(this.props.cardIdentity.filters[filter].selected.includes(opt)) {
						selected.push(opt);
					}
				})
				filters = {
					...filters,
					[filter]: {
						...filters[filter],
						options: [...options],
						selected: [...selected]
					}
				}
			}
		})
		return filters;
	}

	movePhase(dir) {
		let phase = this.state.phase + dir;
		if (phase < 0) {
			phase = 0;
		} else if (phase > 5) {
			phase = 5;
		}
		this.setState({ phase: phase })
	}

	canContinue() {
		let canContinue = false;

		let newCardForm = this.state.newCardForm;
		switch (this.state.phase) {
			case 0:
				canContinue = newCardForm.title.trim().length > 0
				break;
			case 1:
				canContinue = newCardForm.chartType != null;
				break;
			case 2:
				canContinue = newCardForm.dataSet != null;
				break;
			case 3:
				let foundProblem3 = false;
				if (newCardForm.selectedMetrics.length === 0) {
					foundProblem3 = true;
				}
				if(newCardForm.chartType === "table") {
					if (newCardForm.selectedMetrics.filter(x => x.isYOY === false).length > this.props.cardMetricLimits[newCardForm.chartType]) {
						foundProblem3 = true;
					}
					if (newCardForm.selectedMetrics.filter(x => x.isYOY === true).length > this.props.cardMetricLimits["yoy"]) {
						foundProblem3 = true;
					}
				} else {
					if (newCardForm.selectedMetrics.length > this.props.cardMetricLimits[newCardForm.chartType]) {
						foundProblem3 = true;
					}
				}
				if (newCardForm.isGroupable && newCardForm.groupables.length === 0) {
					foundProblem3 = true;
				}
				if (newCardForm.chartType === "table" && newCardForm.supportFields.length === 0) {
					foundProblem3 = true;
				}
				canContinue = !foundProblem3;
				break;
			case 4:
				canContinue = true;
				break;
		}

		return canContinue;
	}

	createNewCardFilters() {
		let newCardForm = this.state.newCardForm;

		if (this.props.defaultFilters[newCardForm.dataSet]) {

			let cardFilters = {};

			Object.keys(this.props.defaultFilters[newCardForm.dataSet]).forEach(key => {
				let filter = this.props.defaultFilters[newCardForm.dataSet][key];
				cardFilters[key] = {
					label: filter.label,
					map: filter.map,
					options: Object.values(filter.options),
					selected: Object.values(filter.selected)
				}
			})

			newCardForm.filters = cardFilters;
		}

		this.setState({ newCardForm: newCardForm, filters:{...newCardForm.filters} });
		return newCardForm;
	}

	handleNewCardTitleInput(e) {
		let newCardForm = this.state.newCardForm;

		let value = e.target.value;

		if (value.length <= 40) {
			newCardForm.title = value;
		}

		this.setState({ newCardForm: newCardForm })

	}

	selectChartType(chartType) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.chartType !== chartType) {
			if(((chartType === "pie" || chartType === "line" || chartType === "card") && (newCardForm.chartType !== "pie" && newCardForm.chartType !== "card" && newCardForm.chartType !== "line")) || (newCardForm.chartType === "table" && (chartType === "stackedBar" || chartType === "bar")) || (newCardForm.chartType === "stackedBar" && chartType === "bar")) {
				newCardForm.selectedMetrics = [];
				newCardForm.groupables = [];
				newCardForm.supportFields = [];
			} else {
				let isMetricPresent = true;
				this.state.newCardForm.selectedMetrics.forEach(el => {
					if(el.isYOY) {
						if(!this.state.metricsYOY[chartType][newCardForm.dataSet].includes(el.metric)) {
							isMetricPresent = false;
						}
					} else {
						if(!this.state.metrics[chartType][newCardForm.dataSet].includes(el.metric)) {
							isMetricPresent = false;
						}
					}
				})
				if(!isMetricPresent) {
					newCardForm.selectedMetrics = [];
					newCardForm.groupables = [];
					newCardForm.supportFields = [];
				}
			}
		}

		newCardForm.chartType = chartType;

		this.setState({ newCardForm: newCardForm });
	}

	selectDataSet(dataSet) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.dataSet !== dataSet) {
			newCardForm.selectedMetrics = [];
			newCardForm.groupables = [];
			newCardForm.supportFields = [];
		}

		newCardForm.dataSet = dataSet;

		this.setState({ newCardForm: newCardForm }, this.createNewCardFilters);
	}

	selectMetric(metric) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.chartType != null) {
			if (this.props.cardMetricLimits[newCardForm.chartType] === 1) {
				newCardForm.selectedMetrics =[...newCardForm.selectedMetrics.filter(x => x.isYOY === true),{ metric: metric, isYOY: false }];
			} else if (newCardForm.selectedMetrics.some(x => x.metric === metric && x.isYOY === false)) {
				newCardForm.selectedMetrics.splice(newCardForm.selectedMetrics.findIndex(x => x.metric === metric && x.isYOY === false), 1);
			} else if (this.props.cardMetricLimits[newCardForm.chartType] > newCardForm.selectedMetrics.filter(x => x.isYOY === false).length) {
				newCardForm.selectedMetrics.push({ metric: metric, isYOY: false })
			}
		}
		if(newCardForm.chartType !== null) {
			if(newCardForm.chartType === 'stackedBar' && newCardForm.stackedBarDatatype === null) {
				if(metric === 'PPC' || metric === 'PPG'){
					if(this.props.metricDefs[this.state.newCardForm.dataSet][metric.toLowerCase()] !== undefined){
						newCardForm.stackedBarDatatype = this.props.metricDefs[this.state.newCardForm.dataSet][metric.toLowerCase()].formatId;
					}
				} else {
					if(this.props.metricDefs[this.state.newCardForm.dataSet][window.toCammelCase(metric)] !== undefined){
						newCardForm.stackedBarDatatype = this.props.metricDefs[this.state.newCardForm.dataSet][window.toCammelCase(metric)].formatId;
					}
				}
			}
		}
		if(newCardForm.selectedMetrics.length === 0 && newCardForm.chartType === 'stackedBar') {
			newCardForm.stackedBarDatatype = null;
		}
		this.setState({ newCardForm: newCardForm});
	}

	selectAllMetrics() {
		let newCardForm = this.state.newCardForm;

		if(newCardForm.chartType != null) {
			if(newCardForm.selectedMetrics.filter(x => x.isYOY === false).length >= this.props.cardMetricLimits[newCardForm.chartType] || newCardForm.selectedMetrics.filter(x => x.isYOY === false).length === this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length) {
				newCardForm.selectedMetrics = newCardForm.selectedMetrics.filter(x => x.isYOY === true);
				if(newCardForm.chartType === 'stackedBar') {
					newCardForm.stackedBarDatatype = null;
				}
			}
			else {
				let metrics = [];
				if(newCardForm.chartType === 'stackedBar') {
					metrics = [];
					this.state.metrics[newCardForm.chartType][newCardForm.dataSet].forEach(el => {
						if(newCardForm.selectedMetrics.length < this.props.cardMetricLimits[newCardForm.chartType] && metrics.length < this.props.cardMetricLimits[newCardForm.chartType]) {
							if(newCardForm.stackedBarDatatype === null) {
								if(el !== 'PPC' || el !== 'PPG') {
									if(this.props.metricDefs[newCardForm.dataSet][window.toCammelCase(el)] !== undefined) {
										newCardForm.stackedBarDatatype = this.props.metricDefs[newCardForm.dataSet][window.toCammelCase(el)].formatId;
										metrics.push(el);
									}
								} else {
									if(this.props.metricDefs[newCardForm.dataSet][el.toLowerCase()] !== undefined) {
										newCardForm.stackedBarDatatype = this.props.metricDefs[newCardForm.dataSet][el.toLowerCase()].formatId;
										metrics.push(el);
									}
								}
							} else {
								if(el !== 'PPC' || el !== 'PPG') {
									if(this.props.metricDefs[newCardForm.dataSet][window.toCammelCase(el)] !== undefined) {
										if(this.props.metricDefs[newCardForm.dataSet][window.toCammelCase(el)].formatId === newCardForm.stackedBarDatatype) {
											metrics.push(el);
										}
									} else {
										if(this.props.metricDefs[newCardForm.dataSet][el.toLowerCase()] !== undefined) {
											if(this.props.metricDefs[newCardForm.dataSet][el.toLowerCase()].formatId === newCardForm.stackedBarDatatype) {
												metrics.push(el);
											}
										}
									}
								}
							}
						}
					})
				} else {
					metrics = [...this.state.metrics[newCardForm.chartType][newCardForm.dataSet].slice(0,this.props.cardMetricLimits[newCardForm.chartType] - newCardForm.selectedMetrics.length)];
				}
				metrics.forEach((metric) => newCardForm.selectedMetrics.push({ metric: metric, isYOY: false }));
			}
		}
		this.setState({ newCardForm: newCardForm });
	}

	searchMetrics(val) {
		let filteredMetrics = [];
		let namingMap = this.props.metricTree[this.state.newCardForm.chartType][this.state.newCardForm.dataSet].map(el => {
			if(this.props.allMaps.kpiNamingMap[el.slice(0,1).toLowerCase() + el.slice(1)] != undefined) {
				return this.props.allMaps.kpiNamingMap[el.slice(0,1).toLowerCase() + el.slice(1)];
			} else {
				return this.props.allMaps.kpiNamingMap[el.toLowerCase()];
			}
			
		})
		let kpiReverseMap = Object.keys(this.props.allMaps.kpiNamingMap).reduce((ret, key) => {
			ret[this.props.allMaps.kpiNamingMap[key]] = key;
			return ret;
		},{})
		let filteredNames = namingMap.filter((el) => {
			return el.toLowerCase().includes(val.toLowerCase());
		})
		filteredMetrics = filteredNames.map(el => {
			return kpiReverseMap[el];
		})
		filteredMetrics = filteredMetrics.map(el => {
			if(el.toLowerCase() === 'ppc' || el.toLowerCase() === 'ppg') {
				return el.toUpperCase();
			}
			return el.slice(0,1).toUpperCase() + el.slice(1);
		})
		const metrics = {
			...this.state.metrics,
			[this.state.newCardForm.chartType]:{
				...this.state.metrics[this.state.newCardForm.chartType],
				[this.state.newCardForm.dataSet]:[...filteredMetrics]
			}
		}
		this.setState({metrics:metrics,searchMetric:val});
	}

	clearMetrics() {
		const metrics = {
			...this.state.metrics,
			[this.state.newCardForm.chartType]:{
				...this.state.metrics[this.state.newCardForm.chartType],
				[this.state.newCardForm.dataSet]:[...this.props.metricTree[this.state.newCardForm.chartType][this.state.newCardForm.dataSet]]
			}
		}
		this.setState({metrics:metrics,searchMetric:""});
	}

	selectYOY(metric) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.chartType != null) {
			if (this.props.cardMetricLimits["yoy"] === 1) {
				newCardForm.selectedMetrics = [...newCardForm.selectedMetrics.filter(x => x.isYOY === true),{ metric: metric, isYOY: true }];
			} else if (newCardForm.selectedMetrics.some(x => x.metric === metric && x.isYOY === true)) {
				newCardForm.selectedMetrics.splice(newCardForm.selectedMetrics.findIndex(x => x.metric === metric && x.isYOY === true), 1);
			} else if (this.props.cardMetricLimits["yoy"] > newCardForm.selectedMetrics.filter(x => x.isYOY === true).length) {
				newCardForm.selectedMetrics.push({ metric: metric, isYOY: true })
			}
		}

		this.setState({ newCardForm: newCardForm });
	}

	selectAllYOY() {
		let newCardForm = this.state.newCardForm;

		if(newCardForm.chartType != null) {
			if(newCardForm.selectedMetrics.filter(x => x.isYOY === true).length === this.props.cardMetricLimits["yoy"] || newCardForm.selectedMetrics.filter(x => x.isYOY === true).length === this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length) {
				newCardForm.selectedMetrics = newCardForm.selectedMetrics.filter(x => x.isYOY === false);
			}
			else {
				newCardForm.selectedMetrics = newCardForm.selectedMetrics.filter(x => x.isYOY === false);
				let metrics = [...this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].slice(0,this.props.cardMetricLimits["yoy"])];
				metrics.forEach((metric) => newCardForm.selectedMetrics.push({ metric: metric, isYOY: true }));
			}
		}
		this.setState({ newCardForm: newCardForm });
	}

	searchYOY(val) {
		let filteredMetrics = [];
		filteredMetrics = this.props.metricTree[this.state.newCardForm.chartType][this.state.newCardForm.dataSet].filter((el) => {
			return el.toLowerCase().includes(val.toLowerCase());
		})
		const metrics = {
			...this.state.metricsYOY,
			[this.state.newCardForm.chartType]:{
				...this.state.metricsYOY[this.state.newCardForm.chartType],
				[this.state.newCardForm.dataSet]:[...filteredMetrics]
			}
		}
		this.setState({metricsYOY:metrics,searchYOY:val});
	}

	clearYOY() {
		const metrics = {
			...this.state.metricsYOY,
			[this.state.newCardForm.chartType]:{
				...this.state.metricsYOY[this.state.newCardForm.chartType],
				[this.state.newCardForm.dataSet]:[...this.props.metricTree[this.state.newCardForm.chartType][this.state.newCardForm.dataSet]]
			}
		}
		this.setState({metricsYOY:metrics,searchYOY:""});
	}

	toggleIsGroupable() {
		let newCardForm = this.state.newCardForm;

		newCardForm.isGroupable = !newCardForm.isGroupable;

		this.setState({ newCardForm: newCardForm });
	}

	toggleGrandTotals() {
		let newCardForm = this.state.newCardForm;

		newCardForm.isGrandTotals = !newCardForm.isGrandTotals;

		this.setState({ newCardForm: newCardForm });
	}

	selectGroupable(groupable) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.groupables.includes(groupable)) {
			newCardForm.groupables.splice(newCardForm.groupables.indexOf(groupable), 1);
		} else {
			newCardForm.groupables.push(groupable);
		}

		this.setState({ newCardForm: newCardForm });
	}

	selectAllGroupables(type) {
		let newCardForm = this.state.newCardForm;
		let filteredGroupables = [];
		let groupables = {};
		if(type === 'groupables') {
			if(newCardForm.groupables.length === this.props.groupablesTree[newCardForm.dataSet].length) {
				filteredGroupables = [];
			} else {
				if(this.groupablesState(this.state.groupables[newCardForm.dataSet], newCardForm.groupables,'groupables')) {
					filteredGroupables = [];
				} else {
					this.state.groupables[newCardForm.dataSet].forEach(groupable => {
						if(!newCardForm.groupables.includes(groupable)) {
							filteredGroupables.push(groupable);
						}
					})
					filteredGroupables = [...newCardForm.groupables, ...filteredGroupables];
				}
			}
			groupables = {
				...newCardForm,
				groupables:[...filteredGroupables]
			}
		}
		else if(type === 'support') {
			if(newCardForm.supportFields.length === this.props.groupablesTree[newCardForm.dataSet].length) {
				filteredGroupables = [];
			} else {
				if(this.groupablesState(this.state.supportFields[newCardForm.dataSet], newCardForm.supportFields,'support')) {
					filteredGroupables = [];
				} else {
					this.state.supportFields[newCardForm.dataSet].forEach(supportField => {
						if(!newCardForm.supportFields.includes(supportField)) {
							filteredGroupables.push(supportField);
						}
					})
					filteredGroupables = [...newCardForm.supportFields, ...filteredGroupables];
				}
			}
			groupables = {
				...newCardForm,
				supportFields:[...filteredGroupables]
			}
		}
		this.setState({newCardForm:groupables});
	}

	groupablesState(options,selected, type) {
		let isPresent;
		if(type === 'groupables') {
			isPresent = options.length > 0 || this.state.newCardForm.groupables.length === this.props.groupablesTree[this.state.newCardForm.dataSet].length ? true : false;
		} else {
			isPresent = options.length > 0 || this.state.newCardForm.supportFields.length === this.props.groupablesTree[this.state.newCardForm.dataSet].length ? true : false;
		}
		
		options.forEach(option => {
			if(!selected.includes(option)) {
				isPresent = false;
			}
		})
		return isPresent;
	}

	searchGroupables(val,type) {
		let newCardForm = this.state.newCardForm;
		let filteredGroupables = [];
		let groupable = {};
		if(type === 'groupables') {
			filteredGroupables = this.props.groupablesTree[newCardForm.dataSet].filter((el) => {
				return this.props.allMaps.columnHeaderMap[el.substring(0, 1).toLowerCase() + el.substring(1)].toLowerCase().includes(val.toLowerCase());
			})
			groupable = {
				...this.state.groupables,
				[newCardForm.dataSet]:[...filteredGroupables]
			}
			this.setState({groupables:groupable,searchGroupable:val})
		}
		else if (type === 'support') {
			filteredGroupables = this.props.groupablesTree[newCardForm.dataSet].filter((el) => {
				return this.props.allMaps.columnHeaderMap[el.substring(0, 1).toLowerCase() + el.substring(1)].toLowerCase().includes(val.toLowerCase());
			})
			groupable = {
				...this.state.supportFields,
				[newCardForm.dataSet]:[...filteredGroupables]
			}
			this.setState({supportFields:groupable,searchSupport:val})
		}
	}

	clearAllGroupables(type) {
		const filteredGroupables = this.props.groupablesTree[this.state.newCardForm.dataSet];
		let groupable={};
		if(type === 'groupables') {
			groupable = {
				...this.state.groupables,
				[this.state.newCardForm.dataSet]:[...filteredGroupables]
			}
			this.setState({groupables:groupable,searchGroupable:''});
		} else if(type === 'support') {
			groupable = {
				...this.state.supportField,
				[this.state.newCardForm.dataSet]:[...filteredGroupables]
			}
			this.setState({supportFields:groupable,searchSupport:''})
		}
	}

	selectSupport(supportField) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.supportFields.includes(supportField)) {
			newCardForm.supportFields.splice(newCardForm.supportFields.indexOf(supportField), 1);
		} else {
			newCardForm.supportFields.push(supportField);
		}

		this.setState({ newCardForm: newCardForm });
	}

	toggleIsLocked() {
		let newCardForm = this.state.newCardForm;

		newCardForm.isLocked = !newCardForm.isLocked;

		this.setState({ newCardForm: newCardForm });
	}

	toggleAllDataSelected(filterName) {
		let newCardForm = this.state.newCardForm;
		let filters = [];
		if (newCardForm.filters[filterName]) {
			if(this.filtersState(newCardForm.filters[filterName])) {
				if(newCardForm.filters[filterName].options.length === newCardForm.filters[filterName].selected.length) {
					newCardForm.filters[filterName].selected = [];
				} else {
					newCardForm.filters[filterName].selected.map(f => {
						if(!newCardForm.filters[filterName].options.includes(f)) {
							filters.push(f)
						}
					})
					newCardForm.filters[filterName].selected = [...filters];
				}
			} else {
				newCardForm.filters[filterName].options.map(f => {
					if(!newCardForm.filters[filterName].selected.includes(f)) {
						filters.push(f);
					}
				})
				newCardForm.filters[filterName].selected = [...newCardForm.filters[filterName].selected, ...filters];
			}
		}

		this.setState({ newCardForm: newCardForm });
	}

	searchFilters(val,key) {
		let filteredFilters = [];
		const type = this.state.filters[key].map;
		if(this.props.isEditMode) {
			filteredFilters = this.state.filters[key].options.filter((el) => {
				return this.props.allMaps[type][el].toLowerCase().includes(val.toLowerCase());
			})
		} else {
			filteredFilters = this.state.filters[key].options.filter((el) => {
				return this.props.allMaps[type][el].toLowerCase().includes(val.toLowerCase());
			})
		}
        
        const filter = {
            ...this.state.newCardForm,
            filters: {
				...this.state.newCardForm.filters,
				[key]:{
					...this.state.newCardForm.filters[key],
					options:filteredFilters
				}
			}
        }
        this.setState({newCardForm:filter,search:val});
	}
	
	clearSearch(key) {
        const filter = {
			...this.state.newCardForm,
			filters: {
				...this.state.newCardForm.filters,
				[key]:{
					...this.state.newCardForm.filters[key],
					options:[...this.state.filters[key].options]
				}
			}
        }
        this.setState({newCardForm:filter,search:""});
    }

	filtersState(filter) {
		let isPresent = true;
		filter.options.forEach(f => {
			if(!filter.selected.includes(f)) {
				isPresent = false;
			}
		})
		return isPresent;
	}

	finishCreateVisual() {
		let newCardForm = this.state.newCardForm
		let initialChartType = this.props.isEditMode ? newCardForm.initialChartType !== undefined ? newCardForm.initialChartType : newCardForm.chartType : newCardForm.chartType;
		let tmpCard = {
			chartType: newCardForm.chartType,
			initialChartType: initialChartType,
			dataSet: newCardForm.dataSet,
			stackedBarDatatype: newCardForm.stackedBarDatatype,
			filters: Object.keys(newCardForm.filters).reduce((r, key) => {
				let filter = newCardForm.filters[key]

				r[key] = {
					label: filter.label,
					map: filter.map,
					options: filter.options,
					selected: Object.values(filter.selected)
				}

				return r;
			}, {}),
			isGroupable: newCardForm.isGroupable,
			groupables: newCardForm.isGroupable ? newCardForm.groupables : [],
			isGrandTotals: newCardForm.isGrandTotals,
			isLocked: newCardForm.isLocked,
			selectedMetrics: newCardForm.selectedMetrics.reduce((r, e) => {
				if (this.props.metricTree && this.props.metricTree[newCardForm.chartType] &&
					this.props.metricTree[newCardForm.chartType][newCardForm.dataSet] &&
					this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].includes(e.metric)) {
					r.push(e);
				}

				return r;
			}, []),
			supportFields: newCardForm.chartType === "table" ? newCardForm.supportFields : [],
			title: newCardForm.title
		}
		
		if (this.props.isEditMode) {
			tmpCard.id = newCardForm.id;
			this.props.saveEditVisual(tmpCard);
		} else {
			this.props.createVisual(tmpCard);
		}
	}

	newCardSetActiveFilter(key) {
		let newCardForm = this.state.newCardForm;

		newCardForm.activeFilter = newCardForm.activeFilter === key ? null : key;

		this.setState({ newCardForm: newCardForm });
	}

	newCardMakeFilterSelection(value, filterName) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.filters[filterName] != undefined) {
			let filter = newCardForm.filters[filterName];

			if (filter.options.length > 0 && typeof filter.options[0] === "object") {
				filter.options.forEach(op => {
					if (op.options.includes(value)) {
						if (op.selected.includes(value)) {
							op.selected.splice(op.selected.indexOf(value), 1);
						} else {
							op.selected.push(value);
						}
					}
				})
			}

			if (filter.selected.includes(value)) {
				filter.selected.splice(filter.selected.indexOf(value), 1)
			} else {
				filter.selected.push(value);
			}
		}

		this.setState({ newCardForm: newCardForm });
	}

	newCardMakeFilterMajorSelection(value, filterName) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.filters[filterName] != undefined) {
			let filter = newCardForm.filters[filterName];

			let changeList = []
			let changeAdd = true;

			// filter.selected = [];
			filter.options.forEach(op => {
				if (op.value === value) {
					changeList = op.options;
					if (op.selected.length < op.options.length) {
						changeList.forEach(sub => { if (!op.selected.includes(sub)) { op.selected.push(sub); } })
					} else {
						op.selected = [];
						changeAdd = false;
					}
				}
			});

			if (changeAdd) {
				changeList.forEach(ch => {
					if (!filter.selected.includes(ch)) {
						filter.selected.push(ch);
					}
				})
			} else {
				changeList.forEach(ch => {
					if (filter.selected.includes(ch)) {
						filter.selected.splice(filter.selected.indexOf(ch), 1);
					}
				})
			}
		}

		this.setState({ newCardForm: newCardForm });
	}

	newCardExpandFilterMajor(value) {
		let newCardForm = this.state.newCardForm;

		if (newCardForm.expandedFilterMajors.includes(value)) {
			newCardForm.expandedFilterMajors.splice(newCardForm.expandedFilterMajors.indexOf(value), 1)
		} else {
			newCardForm.expandedFilterMajors.push(value);
		}

		this.setState({ newCardForm: newCardForm });
	}

	metricDatatypeStack(metric) {
		let stackable = true;
		if(metric !== undefined) {
			if(this.state.newCardForm.chartType ==='stackedBar' && this.state.newCardForm.stackedBarDatatype !== null) {
				if(metric === 'PPC' || metric === 'PPG') {
					if(this.props.metricDefs[this.state.newCardForm.dataSet][metric.toLowerCase()] !== undefined) {
						let metricDef = {...this.props.metricDefs[this.state.newCardForm.dataSet][metric.toLowerCase()]};
						if(metricDef.formatId != this.state.newCardForm.stackedBarDatatype) {
							stackable = false;
						}
					}
				} else {
					if(this.props.metricDefs[this.state.newCardForm.dataSet][window.toCammelCase(metric)] !== undefined) {
						let metricDef = {...this.props.metricDefs[this.state.newCardForm.dataSet][window.toCammelCase(metric)]};
						if(metricDef.formatId != this.state.newCardForm.stackedBarDatatype) {
							stackable = false;
						}
					}
				}
				// if(metric === 'PPC'|| metric === 'PPG') {
				// 	if(this.props.metricDefs[this.state.newCardForm.dataSet][metric.toLowerCase()] !== undefined) {
				// 		let metricDef = this.props.metricDefs[this.state.newCardForm.dataSet][metric.toLowerCase()];
				// 		if(metricDef.friendlyName === metric) {
				// 			if(metricDef.formatId !== this.state.newCardForm.stackedBarDatatype) {
				// 				stackable = false;
				// 			}
				// 		}
				// 	}
				// } else {
				// 	if(this.props.metricDefs[this.state.newCardForm.dataSet][window.toCammelCase(metric)] !== undefined) {
				// 		let metricDef = this.props.metricDefs[this.state.newCardForm.dataSet][window.toCammelCase(metric)];
				// 		if(metricDef.friendlyName === metric) {
				// 			if(metricDef.formatId !== this.state.newCardForm.stackedBarDatatype) {
				// 				stackable = false;
				// 			}
				// 		}
				// 	}
				// }
			}
		}
		return stackable;
	}

	//Add back in for V1 once implemented
	//<div className={"chart-option no-bottom-margin" + (newCardForm.chartType === "stackedBar" ? " active" : "")} onClick={this.selectChartType.bind(null, "stackedBar")}>
	//<img src={window.__globalConfig.contentUrl + "./images/Workspaces/StackedBarChartIcon.svg"} />
	//</div>
	generateSlides() {

		let newCardForm = this.state.newCardForm;

		let slides = [];

		let curPhase = 0;
		slides.push((
			<div className={"slide " + (this.state.phase === curPhase ? "center" : this.state.phase > curPhase ? "left" : "right")}>
				<div className={"input-container-outer"}>
					<div className={"label"}>{"Name"}</div>
					<div className={"input-container"}>
						<input
							ref = {(titleInput) => this.state.phase === 0 && titleInput && titleInput.focus()}
							className={"form-input"}
							type={"text"}
							value={newCardForm.title}
							placeholder={"Title"}
							onChange={this.handleNewCardTitleInput}
						/>
						<div className={"highlighter"}></div>
					</div>
				</div>
				<div className={this.props.isEditMode ? this.saveCloseRender() ? "create-visual-button" : "create-visual-button button-disable" : "dispNone"} onClick={ this.saveCloseRender() ? this.finishCreateVisual : '' }>SAVE</div>
			</div>
		))

		curPhase++;
		slides.push((
			<div className={"slide " + (this.state.phase === curPhase ? "center" : this.state.phase > curPhase ? "left" : "right")}>
				<div className={"general-label"}>{"Chart type"}</div>
				<div className={"chart-picker-container"}>
					<div data-trackid = {'create-bar-chart'} title={"Bar chart"} className={"chart-option" + (newCardForm.chartType === "bar" ? " active" : "")} onClick={this.selectChartType.bind(null, "bar")}>
						<img src={window.__globalConfig.contentUrl + "./images/Workspaces/BarChartIcon.svg"} />
					</div>
					<div data-trackid = {'create-line-chart'} title={"Line chart"} className={"chart-option" + (newCardForm.chartType === "line" ? " active" : "")} onClick={this.selectChartType.bind(null, "line")}>
						<img src={window.__globalConfig.contentUrl + "./images/Workspaces/LineChartIcon.svg"} />
					</div>
					<div data-trackid = {'create-pie-chart'} title={"Pie chart"} className={"chart-option no-right-margin" + (newCardForm.chartType === "pie" ? " active" : "")} onClick={this.selectChartType.bind(null, "pie")}>
						<img src={window.__globalConfig.contentUrl + "./images/Workspaces/PieChartIcon.svg"} />
					</div>
					<div data-trackid = {'create-stackedbar-chart'} title={"Stacked Bar Chart"} className={"chart-option no-bottom-margin" + (newCardForm.chartType === "stackedBar" ? " active" : "")} onClick={this.selectChartType.bind(null, "stackedBar")}>
						<img src={window.__globalConfig.contentUrl + "./images/Workspaces/StackedBarChartIcon.svg"} />
					</div>
					<div data-trackid = {'create-card-chart'} title={"Card"} className={"chart-option no-bottom-margin" + (newCardForm.chartType === "card" ? " active" : "")} onClick={this.selectChartType.bind(null, "card")}>
						<img src={window.__globalConfig.contentUrl + "./images/Workspaces/CardIcon.svg"} />
					</div>
					<div data-trackid = {'create-table-chart'} title={"Table"} className={"chart-option no-right-margin no-bottom-margin" + (newCardForm.chartType === "table" ? " active" : "")} onClick={this.selectChartType.bind(null, "table")}>
						<img src={window.__globalConfig.contentUrl + "./images/Workspaces/TableIcon.svg"} />
					</div>
				</div>
				<div className={this.props.isEditMode ? this.saveCloseRender() ? "create-visual-button" : "create-visual-button button-disable" : "dispNone"} onClick={ this.saveCloseRender() ? this.finishCreateVisual : '' }>SAVE</div>
			</div>
		))

		curPhase++;
		let dataSetOptions = []
		let optionContainerHeight = 0;
		//let heightThreshold = window.innerHeight < 750 ? 12 : 18;
		if (newCardForm.chartType != null) {
			Object.keys(this.props.metricTree[newCardForm.chartType]).forEach(dataSet => {
				optionContainerHeight = optionContainerHeight + 3 > this.state.heightThreshold ? this.state.heightThreshold : optionContainerHeight + 3;
				dataSetOptions.push((
					<div data-trackid = {'dataset-' +dataSet }
						className={"option-simple" + (newCardForm.dataSet === dataSet ? " selected" : "")}
						onClick={this.selectDataSet.bind(null, dataSet)}
					>
						<div className={"radiobox"}>
							<div className={"radio"}></div>
						</div>
						<div className={"option-label"}>
							{this.props.allMaps.dataSourceMap[dataSet] ? this.props.allMaps.dataSourceMap[dataSet] : dataSet}
						</div>
					</div>
				))
			})
		}
		slides.push((
			<div className={"slide " + (this.state.phase === curPhase ? "center" : this.state.phase > curPhase ? "left" : "right")}>
				<div className={"general-label"}>{"Data set"}</div>
				<div
					className={"filter-container" + (newCardForm.activeFilter === "data-set" ? " active" : "")}
				>
					<div className={"label"} onClick={this.newCardSetActiveFilter.bind(null, "data-set")}>{this.props.allMaps.dataSourceMap[newCardForm.dataSet] ? this.props.allMaps.dataSourceMap[newCardForm.dataSet] : newCardForm.dataSet}</div>
					<div className={"material-icons drop-icon"} onClick={this.newCardSetActiveFilter.bind(null, "data-set")}>{"arrow_drop_down"}</div>
					<div className={"options-container"} style={{ height: newCardForm.activeFilter === "data-set" ? optionContainerHeight + "rem" : "0rem" }}>
						{dataSetOptions}
					</div>
					<div className={"off-clicker"} onClick={this.newCardSetActiveFilter.bind(null, null)}></div>
				</div>
				<div className={this.props.isEditMode ? this.saveCloseRender() ? "create-visual-button" : "create-visual-button button-disable" : "dispNone"} onClick={ this.saveCloseRender() ? this.finishCreateVisual : '' }>SAVE</div>
			</div>
		))

		curPhase++;
		optionContainerHeight = 0;
		let secondOptionContainerHeight = 0;
		let thirdOptionContainerHeight = 0;
		let selectedMetricsString = "";
		let selectedYOYString = "";
		let selectedGroupablesString = "";
		let selectedSupportString = "";
		let metricMessage = "Metrics";
		let metricOptions = [];
		let yoyOptions = [];
		let groupablesOptions = [];
		let supportOptions = [];
		if (newCardForm.chartType != null && newCardForm.dataSet != null) {
			if (this.props.cardMetricLimits[newCardForm.chartType] > 1) {
				metricMessage = "Metrics (choose up to " + this.props.cardMetricLimits[newCardForm.chartType] + ")"
			}
			if(this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length > 1 && this.props.cardMetricLimits[newCardForm.chartType] > 1) {
				optionContainerHeight = this.state.metrics[newCardForm.chartType][newCardForm.dataSet].length * 3 + 4 > this.state.heightThreshold ? this.state.heightThreshold : this.state.metrics[newCardForm.chartType][newCardForm.dataSet].length * 3 + 4;
				metricOptions.push(
					<div
						className={"option-simple"  + (newCardForm.selectedMetrics.filter(x => x.isYOY === false).length > 0 ? " selected" : "") + (this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length > 1 ? " searchBox":" dispNone")}>
						<div className={"checkbox"} onClick={this.selectAllMetrics.bind(null)}>
							<div className={"material-icons check"}>{newCardForm.selectedMetrics.filter(x => x.isYOY === false).length > 0 && newCardForm.selectedMetrics.filter(x => x.isYOY === false).length < this.props.cardMetricLimits[newCardForm.chartType] && newCardForm.selectedMetrics.filter(x => x.isYOY === false).length != this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length ? "remove" :"check"}</div>
						</div>
						<div className={"searchDiv"}><input value={this.state.searchMetric} onChange={(e) => this.searchMetrics(e.target.value)} className={"searchField"} placeholder={"Search.."}></input></div>
						<div className={"clearBtn"} onClick={() => this.clearMetrics()}>
							<div className={"material-icons"}>{"clear"}</div>
						</div>
					</div>
				)
			}
			else {
				optionContainerHeight = this.state.metrics[newCardForm.chartType][newCardForm.dataSet].length * 3 > this.state.heightThreshold ? this.state.heightThreshold : this.state.metrics[newCardForm.chartType][newCardForm.dataSet].length * 3;
			}
			let tempMetrics = this.state.metrics[newCardForm.chartType][newCardForm.dataSet];
			tempMetrics.sort((a, b) => {
			const metricDisplayA = this.props.allMaps.kpiNamingMap[a.substring(0, 1).toLowerCase() + a.substring(1)] || a;
			const metricDisplayB = this.props.allMaps.kpiNamingMap[b.substring(0, 1).toLowerCase() + b.substring(1)] || b;
			return metricDisplayA.localeCompare(metricDisplayB);
			});

			tempMetrics.forEach(metric => {
			let metricDisplay = this.props.allMaps.kpiNamingMap[metric.substring(0, 1).toLowerCase() + metric.substring(1)];
			if (!metricDisplay) {
				metricDisplay = metric;
			}
			if (newCardForm.selectedMetrics.some(x => x.metric === metric && x.isYOY === false)) {
				selectedMetricsString = selectedMetricsString === "" ? metricDisplay : selectedMetricsString + ", " + metricDisplay;
			}
			metricOptions.push((
				<div
				data-trackid={'metric-' + metric}
				className={(this.metricDatatypeStack(metric) ? " " : "option-disabled") + " option-simple" + (newCardForm.selectedMetrics.some(x => x.metric === metric && x.isYOY === false) ? " selected" : "")}
				onClick={this.metricDatatypeStack(metric) ? this.selectMetric.bind(null, metric) : ""}
				>
				<div className={this.props.cardMetricLimits[newCardForm.chartType] === 1 ? "radiobox" : "checkbox"}>
					{this.props.cardMetricLimits[newCardForm.chartType] === 1 ? <div className={"radio"}></div> : <div className={"material-icons check"}>{"check"}</div>}
				</div>
				<div className={"option-label"}>
					{metricDisplay}
				</div>
				</div>
			));
			});
			// YOY Dropdown -Start
			if(this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length > 1 && this.props.cardMetricLimits["yoy"] > 1) {
				optionContainerHeight = this.state.metricsYOY[newCardForm.chartType][newCardForm.dataSet].length * 3 + 4 > 18 ? 18 : this.state.metricsYOY[newCardForm.chartType][newCardForm.dataSet].length * 3 + 4;
				yoyOptions.push(
					<div
						className={"option-simple"  + (newCardForm.selectedMetrics.filter(x => x.isYOY === true).length > 0 ? " selected" : "") + (this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length > 1 ? " searchBox":" dispNone")}>
						<div className={"checkbox"} onClick={this.selectAllYOY.bind(null)}>
							<div className={"material-icons check"}>{newCardForm.selectedMetrics.filter(x => x.isYOY === true).length > 0 && newCardForm.selectedMetrics.filter(x => x.isYOY === true).length != this.props.cardMetricLimits[newCardForm.chartType] && newCardForm.selectedMetrics.filter(x => x.isYOY === true).length != this.props.metricTree[newCardForm.chartType][newCardForm.dataSet].length ? "remove" :"check"}</div>
						</div>
						<div className={"searchDiv"}><input value={this.state.searchYOY} onChange={(e) => this.searchYOY(e.target.value)} className={"searchField"} placeholder={"Search.."}></input></div>
						<div className={"clearBtn"} onClick={() => this.clearYOY()}>
							<div className={"material-icons"}>{"clear"}</div>
						</div>
					</div>
				)
			}
			else {
				optionContainerHeight = this.state.metricsYOY[newCardForm.chartType][newCardForm.dataSet].length * 3 > 18 ? 18 : this.state.metricsYOY[newCardForm.chartType][newCardForm.dataSet].length * 3;
			}

			this.state.metricsYOY[newCardForm.chartType][newCardForm.dataSet].forEach(metric => {
				let YOYDisplay = this.props.allMaps.kpiNamingMap[metric.substring(0, 1).toLowerCase() + metric.substring(1)];
				if (!YOYDisplay) { YOYDisplay = metric; }
				if (newCardForm.selectedMetrics.some(x => x.metric === metric && x.isYOY === true)) {
					selectedYOYString = selectedYOYString === "" ? YOYDisplay : selectedYOYString + ", " + YOYDisplay;
				}
				yoyOptions.push((
					<div data-trackid = {'yoy-'+metric}
						className={"option-simple" + (newCardForm.selectedMetrics.some(x => x.metric === metric && x.isYOY === true) ? " selected" : "")}
						onClick={this.selectYOY.bind(null, metric)}
					>
						<div className={this.props.cardMetricLimits[newCardForm.chartType] === 1 ? "radiobox" : "checkbox"}>
							{this.props.cardMetricLimits[newCardForm.chartType] === 1 ? <div className={"radio"}></div> : <div className={"material-icons check"}>{"check"}</div>}
						</div>
						<div className={"option-label"}>
							{YOYDisplay}
						</div>
					</div>
				));
			})
			// YOY Dropdown - End
			if(this.props.groupablesTree[newCardForm.dataSet].length > 1) {
				secondOptionContainerHeight = this.state.groupables[newCardForm.dataSet].length * 3 + 4 > this.state.heightThreshold ? this.state.heightThreshold : this.state.groupables[newCardForm.dataSet].length * 3 + 4;
				groupablesOptions.push(
					<div
						className={"option-simple"  + (newCardForm.groupables.length > 0 ? " selected" : "") + (this.props.groupablesTree[newCardForm.dataSet].length > 1 ? " searchBox":" dispNone")}>
						<div className={"checkbox"} onClick={this.selectAllGroupables.bind(null,'groupables')}>
							<div className={"material-icons check"}>{!this.groupablesState(this.state.groupables[newCardForm.dataSet], newCardForm.groupables,'groupables')? "remove" :"check"}</div>
						</div>
						<div className={"searchDiv"}><input value={this.state.searchGroupable} onChange={(e) => this.searchGroupables(e.target.value,'groupables')} className={"searchField"} placeholder={"Search.."}></input></div>
						<div className={"clearBtn"} onClick={() => this.clearAllGroupables('groupables')}>
							<div className={"material-icons"}>{"clear"}</div>
						</div>
					</div>
				)
			}
			else {
				secondOptionContainerHeight = this.state.groupables[newCardForm.dataSet].length * 3 > this.state.heightThreshold ? this.state.heightThreshold : this.state.groupables[newCardForm.dataSet].length * 3;
			}
			this.state.groupables[newCardForm.dataSet].forEach(groupable => {
				
				let groupableDisplay = this.props.allMaps.columnHeaderMap[groupable.substring(0, 1).toLowerCase() + groupable.substring(1)];
				if (!groupableDisplay) { groupableDisplay = groupable }
				if (newCardForm.groupables.includes(groupable)) {
					selectedGroupablesString = selectedGroupablesString === "" ? groupableDisplay : selectedGroupablesString + ", " + groupableDisplay;
				}
				groupablesOptions.push((
					<div data-trackid = {'groupable-'+groupableDisplay}
						className={"option-simple" + (newCardForm.groupables.includes(groupable) ? " selected" : "")}
						onClick={this.selectGroupable.bind(null, groupable)}
					>
						<div className={"checkbox"}>
							<div className={"material-icons check"}>{"check"}</div>
						</div>
						<div className={"option-label"}>
							{groupableDisplay}
						</div>
					</div>
				));
			})
			if (newCardForm.chartType === "table") {
				if(this.props.groupablesTree[newCardForm.dataSet].length > 1) {
					thirdOptionContainerHeight = this.state.supportFields[newCardForm.dataSet].length * 3 + 4 > this.state.heightThreshold ? this.state.heightThreshold : this.state.supportFields[newCardForm.dataSet].length * 3 + 4;
					supportOptions.push(
						<div
							className={"option-simple"  + (newCardForm.supportFields.length > 0 ? " selected" : "") + (this.props.groupablesTree[newCardForm.dataSet].length > 1 ? " searchBox":" dispNone")}>
							<div className={"checkbox"} onClick={this.selectAllGroupables.bind(null,'support')}>
								<div className={"material-icons check"}>{!this.groupablesState(this.state.supportFields[newCardForm.dataSet], newCardForm.supportFields,'support') ? "remove" :"check"}</div>
							</div>
							<div className={"searchDiv"}><input value={this.state.searchSupport} onChange={(e) => this.searchGroupables(e.target.value,'support')} className={"searchField"} placeholder={"Search.."}></input></div>
							<div className={"clearBtn"} onClick={() => this.clearAllGroupables('support')}>
								<div className={"material-icons"}>{"clear"}</div>
							</div>
						</div>
					)
				}
				else {
					thirdOptionContainerHeight = this.state.supportFields[newCardForm.dataSet].length * 3 > this.state.heightThreshold ? this.state.heightThreshold : this.state.supportFields[newCardForm.dataSet].length * 3;
				}
				this.state.supportFields[newCardForm.dataSet].forEach(supportField => {
					let supportFieldDisplay = this.props.allMaps.columnHeaderMap[supportField.substring(0, 1).toLowerCase() + supportField.substring(1)];
					if (!supportFieldDisplay) { supportFieldDisplay = supportField }

					newCardForm.isGroupable = true;
					if (newCardForm.supportFields.includes(supportField)) {
						selectedSupportString = selectedSupportString === "" ? supportFieldDisplay : selectedSupportString + ", " + supportFieldDisplay;
					}
					supportOptions.push((
						<div data-trackid = {'supportOpt-' + supportFieldDisplay}
							className={"option-simple" + (newCardForm.supportFields.includes(supportField) ? " selected" : "")}
							onClick={this.selectSupport.bind(null, supportField)}
						>
							<div className={"checkbox"}>
								<div className={"material-icons check"}>{"check"}</div>
							</div>
							<div className={"option-label"}>
								{supportFieldDisplay}
							</div>
						</div>
					));
				})
			}
		}
		slides.push((
			<div className={"slide " + (this.state.phase === curPhase ? "center" : this.state.phase > curPhase ? "left" : "right")}>
				<div className={"general-label"}>{metricMessage}</div>
				<div
					className={"filter-container" + (newCardForm.activeFilter === "metrics" ? " active" : "")}
				>
					<div className={"label"} onClick={this.newCardSetActiveFilter.bind(null, "metrics")}>{selectedMetricsString}</div>
					<div className={"material-icons drop-icon"} onClick={this.newCardSetActiveFilter.bind(null, "metrics")}>{"arrow_drop_down"}</div>
					<div className={"options-container"} style={{ height: newCardForm.activeFilter === "metrics" ? optionContainerHeight + "rem" : "0rem" }}>
						{metricOptions}
					</div>
					<div className={"off-clicker"} onClick={this.newCardSetActiveFilter.bind(null, null)}></div>
				</div>
				{newCardForm.chartType === "table" ?
					(
						<>
							<div className={"general-label"}>{"YOY Metrics (choose up to " + this.props.cardMetricLimits["yoy"] + ")"}</div>
							<div
								className={"filter-container" + (newCardForm.activeFilter === "yoy" ? " active" : "")}
							>
								<div className={"label"} onClick={this.newCardSetActiveFilter.bind(null, "yoy")}>{selectedYOYString}</div>
								<div className={"material-icons drop-icon"} onClick={this.newCardSetActiveFilter.bind(null, "yoy")}>{"arrow_drop_down"}</div>
								<div className={"options-container"} style={{ height: newCardForm.activeFilter === "yoy" ? optionContainerHeight + "rem" : "0rem" }}>
									{yoyOptions}
								</div>
								<div className={"off-clicker"} onClick={this.newCardSetActiveFilter.bind(null, null)}></div>
							</div>
							<div className={"switch-container"} onClick={this.toggleGrandTotals}>
								<div className={"switch-text"}>{"Grand Totals"}</div>
								<div className={"switch" + (newCardForm.isGrandTotals ? " active" : "")}>
									<div className={"knob"} ></div>
								</div>
							</div>
						</>
					)
					: null}
				<div className={"switch-container"} onClick={this.toggleIsGroupable}>
					<div className={"switch-text"}>{"Group data" + (newCardForm.chartType === "table" ? " (Required)" : "")}</div>
					<div className={"switch" + (newCardForm.isGroupable ? " active" : "") + (newCardForm.chartType === "table" ? " disabled" : "")}>
						<div className={"knob"} ></div>
					</div>
				</div>
				<div
					className={"filter-container" + (newCardForm.activeFilter === "groupable" ? " active" : "") + (newCardForm.isGroupable ? "" : " disabled")}
				>
					<div className={"label"} onClick={this.newCardSetActiveFilter.bind(null, "groupable")}>{selectedGroupablesString}</div>
					<div className={"material-icons drop-icon"} onClick={this.newCardSetActiveFilter.bind(null, "groupable")}>{"arrow_drop_down"}</div>
					<div className={"options-container"} style={{ height: newCardForm.activeFilter === "groupable" ? secondOptionContainerHeight + "rem" : "0rem" }}>
						{groupablesOptions}
					</div>
					<div className={"off-clicker"} onClick={this.newCardSetActiveFilter.bind(null, null)}></div>
				</div>
				{newCardForm.chartType != "table" ? null : (
					<div className={"general-label"}>{"Supporting info" + (newCardForm.chartType === "table" ? " (Required)" : "")}</div>
				)}
				{newCardForm.chartType != "table" ? null : (
					<div
						className={"filter-container" + (newCardForm.activeFilter === "support-field" ? " active" : "")}
					>
						<div className={"label"} onClick={this.newCardSetActiveFilter.bind(null, "support-field")}>{selectedSupportString}</div>
						<div className={"material-icons drop-icon"} onClick={this.newCardSetActiveFilter.bind(null, "support-field")}>{"arrow_drop_down"}</div>
						<div className={"options-container"} style={{ height: newCardForm.activeFilter === "support-field" ? thirdOptionContainerHeight + "rem" : "0rem" }}>
							{supportOptions}
						</div>
						<div className={"off-clicker"} onClick={this.newCardSetActiveFilter.bind(null, null)}></div>
					</div>
				)}
				<div className={this.props.isEditMode ? this.saveCloseRender() ? "create-visual-button" : "create-visual-button button-disable" : "dispNone"} onClick={ this.saveCloseRender() ? this.finishCreateVisual : '' }>SAVE</div>
			</div>
		))

		curPhase++;
		optionContainerHeight = 0;
		let optionsJsxCount = 0;
		let filterListJsx = [];
		if (newCardForm.chartType != null && newCardForm.dataSet != null) {
			Object.keys(newCardForm.filters).forEach(key => {

				optionContainerHeight = 0;
				let f = newCardForm.filters[key];
				let optionsJsx = [];

				if(this.props.isEditMode) {
					optionContainerHeight = optionContainerHeight + 4 > this.state.heightThreshold ? this.state.heightThreshold : f.options.length > 1 || this.state.filters[key] === undefined ? f.options.length > 1 ? optionContainerHeight + 4 : optionContainerHeight : this.state.filters[key].options.length > 1 ? optionContainerHeight + 4 : optionContainerHeight;
					optionsJsx.push((
						<div
							className={"option-simple"  + (f.selected.length > 0 ? " selected" : "") + (this.state.filters[key] === undefined ? f.options.length > 1 ? " searchBox":" dispNone" : this.state.filters[key].options.length > 1 ? " searchBox":" dispNone" )}>
							<div className={"checkbox"} onClick={this.toggleAllDataSelected.bind(null, key)}>
							<div className={"material-icons check"}>{!this.filtersState(f) ? "remove" :"check"}</div>
						</div>
						<div className={"searchDiv"}><input value={this.state.search} onChange={(e) => this.searchFilters(e.target.value,key)} className={"searchField"} placeholder={"Search.."}></input></div>
                        <div className={"clearBtn"} onClick={() => this.clearSearch(key)}>
                            <div className={"material-icons"}>{"clear"}</div>
                        </div>
						</div>
					))
				} else {
					optionContainerHeight = optionContainerHeight + 4 > this.state.heightThreshold ? this.state.heightThreshold : f.options.length > 1 || this.state.filters[key].options.length > 1 ? optionContainerHeight + 4 : optionContainerHeight;
					optionsJsx.push((
						<div
							className={"option-simple"  + (f.selected.length > 0 ? " selected" : "") + (this.state.filters[key].options.length > 1 ? " searchBox":" dispNone")}>
							<div className={"checkbox"} onClick={this.toggleAllDataSelected.bind(null, key)}>
							<div className={"material-icons check"}>{f.selected.length > 0 && f.selected.length != f.options.length ? "remove" :"check"}</div>
						</div>
						<div className={"searchDiv"}><input value={this.state.search} onChange={(e) => this.searchFilters(e.target.value,key)} className={"searchField"} placeholder={"Search.."}></input></div>
                        <div className={"clearBtn"} onClick={() => this.clearSearch(key)}>
                            <div className={"material-icons"}>{"clear"}</div>
                        </div>
						</div>
					))
				}				

				if (f.options.length > 0 && typeof f.options[0] === "object") {
					optionsJsxCount++;
					optionContainerHeight = optionContainerHeight + 3 > this.state.heightThreshold ? this.state.heightThreshold  : optionContainerHeight + 3;


				} else {
					f.options.forEach(op => {
						optionsJsxCount++;
						optionContainerHeight = optionContainerHeight + 3 > this.state.heightThreshold ? this.state.heightThreshold: optionContainerHeight + 3;
						optionsJsx.push((
							<div
								className={"option-simple" + (f.selected.includes(op) ? " selected" : "")}
								onClick={this.newCardMakeFilterSelection.bind(null, op, key)}
							>
								<div className={"checkbox"}>
									<div className={"material-icons check"}>{"check"}</div>
								</div>
								<div className={"option-label"}>
									{f.map != null && f.map != undefined &&
										this.props.allMaps[f.map] != undefined && this.props.allMaps[f.map][op] != undefined ? this.props.allMaps[f.map][op] : op}
								</div>
							</div>
						));
					});
				}

				filterListJsx.push((
					<div data-trackid = {'create-chart-filter-' +key}
						className={"filter-container" + (newCardForm.activeFilter === "filter-" + key ? " active" : "")}
					>
						<div className={"label"} onClick={this.newCardSetActiveFilter.bind(null, "filter-" + key)}>
							{f.selected.length === f.options.length ? "All " + (generateFriendlyName(key, false).slice(-1) === "y" ? generateFriendlyName(key, false).slice(0, -1) + "ies" : generateFriendlyName(key, false) + "s")
								: (generateFriendlyName(key, false).slice(-1) === "y" ? generateFriendlyName(key, false).slice(0, -1) + "ies" : generateFriendlyName(key, false) + "s")}
						</div>
						<div className={"material-icons drop-icon"} onClick={this.newCardSetActiveFilter.bind(null, "filter-" + key)}>{"arrow_drop_down"}</div>
						<div className={"options-container"} style={{ height: newCardForm.activeFilter === "filter-" + key ? optionContainerHeight + "rem" : "0rem" }}>
							{optionsJsx}
						</div>
						<div className={"off-clicker"} onClick={this.newCardSetActiveFilter.bind(null, null)}></div>
					</div>
				))
			});
		}
		slides.push((
			<div className={"slide " + (this.state.phase === curPhase ? "center" : this.state.phase > curPhase ? "left" : "right")}>
				<div className={"switch-container"} onClick={this.toggleIsLocked}>
					<div className={"switch-text"}>{"Lock chart"}</div>
					<div className={"switch" + (newCardForm.isLocked ? " active" : "")}>
						<div className={"knob"}></div>
					</div>
				</div>
				<div className={"general-label"}>{"Filter"}</div>
				{filterListJsx}
				<div className={this.props.isEditMode ? this.saveCloseRender() ? "create-visual-button" : "create-visual-button button-disable" : "dispNone"} onClick={ this.saveCloseRender() ? this.finishCreateVisual : '' }>SAVE</div>
			</div>
		))

		curPhase++;
		optionContainerHeight = 0;
		slides.push((
			<div className={"slide " + (this.state.phase === curPhase ? "center" : this.state.phase > curPhase ? "left" : "right")}>
				<div className={"general-label centered final"}>{this.props.isEditMode ? "Finished editing this chart for your dashboard?" : "Ready to see this chart in your dashboard? Tap Create."}</div>
				<div className={"create-visual-button"} onClick={this.finishCreateVisual}>{this.props.isEditMode ? "SAVE" : "CREATE"}</div>
			</div>
		))

		return slides;
	}

	saveCloseRender() {
		let cssClass;
		if(this.state.newCardForm.chartType === 'table') {
			cssClass = this.state.newCardForm.selectedMetrics.length > 0 && this.state.newCardForm.supportFields.length > 0 && this.state.newCardForm.groupables.length > 0 ? true : false;
			return cssClass;
		} else {
			cssClass = this.state.newCardForm.selectedMetrics.length > 0 ? true : false;
			return cssClass;
		}
	}

	render() {

		let saveOffset = this.props.isEditMode && this.state.phase < 5 ? 4 : 0
		let outerHeight = "27.25rem";
		if (this.outerHeights[this.state.phase] != undefined) {
			outerHeight = this.outerHeights[this.state.phase] + saveOffset + "rem";
			if (this.state.phase === 3 && this.state.newCardForm.chartType === "table") {
				outerHeight = 36.25 + saveOffset +"rem";
			} else if (this.state.phase === 4) {
				outerHeight = 12.5 + Object.keys(this.state.newCardForm.filters).length * 4 + saveOffset + "rem";
			}
		}

		return (
			<div className={"workspace-new-card-modal"} style={{ height: outerHeight }}>
				<div className={"workspace-new-card-title"}>{this.props.isEditMode ? "Edit chart" : "Create chart"}</div>
				<div className={"material-icons back-button" + (this.state.phase === 0 ? "" : " hidden")} onClick={this.props.closeModal}>{"close"}</div>
				<div className={"material-icons back-button" + (this.state.phase === 0 ? " hidden" : "")} onClick={this.movePhase.bind(null, -1)}>{"arrow_back"}</div>
				<div className={"material-icons next-button" + (this.state.phase === 5 || !this.canContinue() ? " hidden" : "")} onClick={this.movePhase.bind(null, 1)}>{"arrow_forward"}</div>
				{this.generateSlides()}
			</div>
		);
	}
}